import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearNotificationStatus, setNotificationStatus } from '../../../../redux/notifier/notifierReducer';

function Navig8NotificationBarController() {
  const dispatch = useDispatch();

  const navig8AbortController = useSelector((state) => state.sonarDashboard.navig8AbortController);
  const isNavig8Generating = useMemo(() => !!navig8AbortController, [navig8AbortController]);

  useEffect(() => {
    if (isNavig8Generating) {
      dispatch(setNotificationStatus('navig8DataIsLoading'));
    } else {
      dispatch(clearNotificationStatus());
    }

    return () => {
      dispatch(clearNotificationStatus());
    };
  }, [isNavig8Generating, dispatch]);

  return null;
}

export default Navig8NotificationBarController;
